import axios from 'axios'
import {
  token
} from './interceptors'

const instance = axios.create({
  baseURL: 'https://api-stage.yessspad.com'
})

token(instance)

export default instance



// WEBPACK FOOTER //
// ./src/services/api/http/index.js